module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE STUDENTS")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "mr-10",
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "no-match-text": "No data",
      "noDataText": "No data",
      "clearable": "",
      "placeholder": "Trip"
    },
    on: {
      "change": _vm.getselectlist
    },
    model: {
      value: (_vm.selecttripvalue),
      callback: function($$v) {
        _vm.selecttripvalue = $$v
      },
      expression: "selecttripvalue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 11
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('a', {
    staticClass: "white",
    attrs: {
      "href": _vm.templateUrl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" Template")])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "upload",
    attrs: {
      "accept": ".xlsx",
      "show-file-list": false,
      "action": "/api/student/import",
      "on-success": _vm.importStudent,
      "on-error": _vm.failUpload,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-upload"
  }), _vm._v(" Import")])], 1)], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "data": _vm.users,
      "border": "",
      "element-loading-text": "loading..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "school",
      "label": "Affiliation",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trip",
      "label": "Trips",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Edit Enabled",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.editEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "editEnabled", $$v)
            },
            expression: "scope.row.editEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.Editstudent(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.removestudent(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "customClass": "dialogStyle",
      "visible": _vm.Editdialog
    },
    on: {
      "update:visible": function($event) {
        _vm.Editdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Eemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eemail),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eemail", $$v)
      },
      expression: "editform.Eemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Change Password",
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.changePass
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), (_vm.willshow) ? [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Epassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.editform.Epassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Epassword", $$v)
      },
      expression: "editform.Epassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "EconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.editform.EconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EconfirmPassword", $$v)
      },
      expression: "editform.EconfirmPassword"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "EgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EgivenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EgivenName", $$v)
      },
      expression: "editform.EgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "EfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfamilyName", $$v)
      },
      expression: "editform.EfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "EdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EdisplayName", $$v)
      },
      expression: "editform.EdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Affiliation",
      "prop": "Eschool"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Affiliation"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eschool),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eschool", $$v)
      },
      expression: "editform.Eschool"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trips",
      "prop": "trip"
    }
  }, [_c('el-select', {
    attrs: {
      "no-match-text": "No data",
      "no-data-text": "No data",
      "filterable": "",
      "placeholder": "Please select trip"
    },
    on: {
      "change": function($event) {
        _vm.isTripDirty = true
      },
      "visible-change": _vm.showTripList
    },
    model: {
      value: (_vm.dialogtripid),
      callback: function($$v) {
        _vm.dialogtripid = $$v
      },
      expression: "dialogtripid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "EmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmobilePhone", $$v)
      },
      expression: "editform.EmobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Father Phone",
      "prop": "EfatherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Father Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfatherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfatherPhone", $$v)
      },
      expression: "editform.EfatherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mother Phone",
      "prop": "EmotherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mother Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmotherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmotherPhone", $$v)
      },
      expression: "editform.EmotherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline1",
      "prop": "EDeadline1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline1),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline1", $$v)
      },
      expression: "editform.EDeadline1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline2",
      "prop": "EDeadline2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline2),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline2", $$v)
      },
      expression: "editform.EDeadline2"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Editdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.existeddialog_title,
      "visible": _vm.existeddialog,
      "width": "90%",
      "customClass": "dialogWidth-1000"
    },
    on: {
      "update:visible": function($event) {
        _vm.existeddialog = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mb-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "max-height": "250",
      "data": _vm.existedList,
      "border": "",
      "element-loading-text": "loading..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))]), _vm._v(" "), (scope.row.trashed == true) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Deleted",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-delete gary"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-radio-group', {
          model: {
            value: (_vm.ExistAction[props.$index]),
            callback: function($$v) {
              _vm.$set(_vm.ExistAction, props.$index, $$v)
            },
            expression: "ExistAction[props.$index]"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": "Update"
          }
        }, [_vm._v("Update")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": "New"
          }
        }, [_vm._v("New Report")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": "Skip"
          }
        }, [_vm._v("Skip")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "actionIntro p-20"
  }, [_c('li', [_vm._v("Update: 用新导入的学生信息覆盖更新已有信息")]), _vm._v(" "), _c('li', [_vm._v("Skip: 什么也不做跳过此条学生信息")]), _vm._v(" "), _c('li', [_vm._v("New Report: 适用于学生重复参加项目的情况，会将当前报告归档并生成新的报告，请谨慎选择")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.importexitedAllSkip
    }
  }, [_vm._v("All Skip")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.importexitedStu
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7eb81e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Student.vue
// module id = 615
// module chunks = 1